// extracted by mini-css-extract-plugin
export default {"wrap":"zUP2IT","name":"dgVr6I","date":"PAwUwe","text":"Vc1tJX","callout":"IvqIUr"};